import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense, useMemo } from 'react';
import { useIconsTheme } from '../../context';
export default function ChevronDown(props) {
    const theme = useIconsTheme();
    const Icon = useMemo(() => {
        switch (theme) {
            case 'base':
                return lazy(() => import('../svg/base/ChevronDown'));
            case 'bosch':
                return lazy(() => import('../svg/bosch/ChevronDown'));
            case 'gaggenau':
                return lazy(() => import('../svg/gaggenau/ChevronDown'));
            case 'siemens':
                return lazy(() => import('../svg/siemens/ChevronDown'));
        }
    }, [theme]);
    return (_jsx(Suspense, { fallback: _jsx("svg", { ...props, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }), children: _jsx(Icon, { ...props }) }));
}
//# sourceMappingURL=ChevronDown.js.map